module.exports = __webpack_public_path__ + "img/EGS_icon_04.66fce3a4.svg";